<template>
  <v-card class="elevation-4" :outlined="$vuetify.theme.isDark" color="secondary" dark max-width="500px">
    <v-card-text>
      <v-flex xs12 class="text-center white--text">
        {{loadingText}}...
      </v-flex>
      <!-- <v-progress-linear indeterminate color="white" class="mb-0" ></v-progress-linear> -->
      <v-flex xs12 class="mt-2 text-center">
        <v-progress-circular :size="70" :width="7" color="white" indeterminate></v-progress-circular>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'cardLoading',
    props: {
      loadingText: {
        type: String,
        default: () => 'Carregando'
      },
    },
  }
</script>

<style scoped>

</style>